import React from "react";

function ShareButton() {
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Check out this page!",
          text: "Here's something interesting for you 👀",
          url: window.location.href, // current page URL
        });
        console.log("Shared successfully!");
      } catch (error) {
        console.error("Sharing failed:", error);
      }
    } else {
      alert("Sharing is not supported on this browser 😕");
    }
  };

  return (
    <button
      onClick={handleShare}
      style={{ padding: "10px 20px", fontSize: "16px" }}
    >
      1st Option Share this page
    </button>
  );
}

export default function TestShare() {
  return (
    <div>
      <ShareButton />
    </div>
  );
}
